import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import EmployeeCard from './components/employeeCard';
import MessageBox from 'components/MessageBox';
import ListView from 'components/ListView';
import { requestEmployeeList } from 'actionCreators';
import { getRole, getEmployeeList, getEmployeeHasNextPage, getEmployeeLoading } from '../../../../reducers';
import ui from 'redux-ui';
import EmployeeType from 'types/employee';

class EmployeeList extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    ui: PropTypes.shape({
      successMessage: PropTypes.string,
    }),
    updateUI: PropTypes.func.isRequired,
    needsMore: PropTypes.bool,
    loading: PropTypes.bool,
    employees: PropTypes.arrayOf(EmployeeType).isRequired,
    role: PropTypes.string,
  }

  componentDidMount() {
    this.loadEmployees();
  }

  componentWillUnmount() {
    if (this.props.ui.successMessage) {
      this.props.updateUI('successMessage', '');
    }
  }

  loadEmployees() {
    const { dispatch } = this.props;
    dispatch(requestEmployeeList());
  }

  handleInfiniteLoad = () => {
    if (this.props.needsMore) {
      this.loadEmployees();
    }
  }

  render() {
    const { employees, needsMore, loading } = this.props;

    return (
      <div>
        {this.props.ui.successMessage
          ? <MessageBox message={this.props.ui.successMessage} />
          : null
        }
        <ListView
          loading={loading}
          needsMore={needsMore}
          handleInfiniteLoad={this.handleInfiniteLoad}
        >
          {employees.map(employee =>
            <EmployeeCard
              key={`employee-${employee.id}`}
              employee={employee}
            />,
          )}
        </ListView>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  employees: getEmployeeList(state),
  needsMore: getEmployeeHasNextPage(state),
  loading: getEmployeeLoading(state),
  role: getRole(state),
});

export default ui()(connect(
  mapStateToProps,
)(EmployeeList));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/employees/employeeList.jsx